export const isAMarketplacePage = (): boolean => {
  const isAVendorPage = new RegExp('^/wedding-vendors');
  const isAFavoritePage = new RegExp('^/favorites');
  const isANotificationsPage = new RegExp('^/notifications');
  const isARealWeddingsPage = new RegExp('^/inspiration');
  return (
    isAVendorPage.test(window.location.pathname) ||
    isAFavoritePage.test(window.location.pathname) ||
    isANotificationsPage.test(window.location.pathname) ||
    isARealWeddingsPage.test(window.location.pathname)
  );
};
